import React, { useState, useContext } from "react";
import { connect } from "react-redux";
import {
  Box,
  Container,
  Typography,
  IconButton,
  Tooltip,
  Menu,
  MenuItem,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import styleCss from "./style.module.css";
import { useStyles } from "./style";
import { APP_URLS } from "../../../utils/constant";
import { removeWordAfterAt } from "../../../utils";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ConfirmRouteChange from "../../ConfirmRouteChange";
import { getIsFormDirty } from "../../../redux/Selectors/formState";
import { setIsformDirty } from "../../../redux/actions/common/form";
import { CustomThemeContext } from "../../ThemeProvider/CustomThemeProvider";

function Header(props) {
  const { isFormDirty, setIsformDirty } = props;
  const classes = useStyles();
  const navigate = useNavigate();
  const { currentTheme, setTheme } = useContext(CustomThemeContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleThemeToggle = () => {
    setTheme(currentTheme === "light" ? "dark" : "light");
  };

  const handleLogout = () => {
    handleMenuClose();
    const favorites = localStorage.getItem("favorites");
    const appTheme = localStorage.getItem("appTheme");
    localStorage.clear();
    if (favorites) {
      localStorage.setItem("favorites", favorites);
    }
    if (appTheme) {
      localStorage.setItem("appTheme", appTheme);
    }
    window.location.replace("/");
  };

  const handleProfileClick = () => {
    handleMenuClose();
    navigate(APP_URLS.CHANGEPASSWORD);
  };

  const handleLogoClick = () => {
    navigate(APP_URLS.DASHBOARD);
  };

  const ConfirmRouteChangeProps = {
    isFormDirty,
    setIsformDirty,
  };

  return (
    <Box className={classes.topnav}>
      <Container
        maxWidth=""
        className={styleCss.header}
        sx={{ px: { xs: 0, sm: 2 } }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            height: 60,
            background: "linear-gradient(135deg, #5b7ab8 0%, #3c5a98 100%)",
            px: { xs: 1, sm: 0 },
            position: "relative",
          }}
        >
          {props.isMobile && (
            <Box sx={{ minWidth: 48, display: "flex", alignItems: "center" }}>
              <IconButton
                color="inherit"
                aria-label="toggle drawer"
                edge="start"
                onClick={props.onMenuClick}
                sx={{
                  display: "flex",
                  ml: { xs: 0, sm: 1 },
                  color: "#ffffff",
                }}
              >
                {props.sideNavOpen ? (
                  <CloseIcon sx={{ color: "#fff" }} />
                ) : (
                  <MenuIcon sx={{ color: "#fff" }} />
                )}
              </IconButton>
            </Box>
          )}

          <Box
            sx={{
              flex: { xs: 1, md: "0 0 auto" },
              display: "flex",
              alignItems: "center",
              justifyContent: { xs: "flex-start", md: "center" },
              height: "100%",
              pl: { xs: 1, md: 0 },
            }}
          >
            <Box
              onClick={handleLogoClick}
              sx={{
                backgroundColor: "transparent",
                borderRadius: 0,
                width: { xs: "auto", md: "280px" },
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              <img
                className={styleCss.logo}
                src="/RezRevolution-logo.png"
                alt="logo"
                style={{
                  maxWidth: "100%",
                }}
              />
            </Box>
          </Box>

          {/* User profile and dark mode - hidden on mobile, shown in side menu */}
          <Box
            sx={{
              minWidth: 48,
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              justifyContent: "flex-end",
              flex: "0 0 auto",
              ml: "auto",
              mr: { xs: 1, sm: 2, md: 3 },
              zIndex: 2,
              gap: 1,
            }}
          >
            <Box
              onClick={handleMenuClick}
              aria-controls={open ? "user-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                cursor: "pointer",
                padding: "8px 12px",
                borderRadius: "8px",
                transition: "background-color 0.3s ease",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                },
              }}
            >
              <AccountCircleIcon sx={{ color: "#fff", fontSize: 24 }} />
              <Typography sx={{ color: "#fff", fontSize: 14, fontWeight: 500 }}>
                {removeWordAfterAt(localStorage.getItem("username"))}
              </Typography>
            </Box>

            <Menu
              id="user-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleMenuClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              PaperProps={{
                elevation: 3,
                sx: {
                  mt: 1,
                  minWidth: 150,
                  borderRadius: "8px",
                  "& .MuiMenuItem-root": {
                    padding: "10px 16px",
                    fontSize: "14px",
                    "&:hover": {
                      backgroundColor: "#f5f5f5",
                    },
                  },
                },
              }}
            >
              <MenuItem onClick={handleProfileClick}>Profile</MenuItem>
              <MenuItem
                onClick={handleLogout}
                sx={{
                  color: "#d32f2f",
                  "&:hover": {
                    backgroundColor: "#ffebee !important",
                  },
                }}
              >
                Logout
              </MenuItem>
            </Menu>

            {/* Dark Mode Toggle */}
            <Tooltip
              title={
                currentTheme === "light"
                  ? "Switch to Dark Mode"
                  : "Switch to Light Mode"
              }
            >
              <IconButton
                onClick={handleThemeToggle}
                sx={{
                  color: "#fff",
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  borderRadius: "8px",
                  padding: "8px",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.2)",
                    transform: "rotate(20deg)",
                  },
                }}
              >
                {currentTheme === "light" ? (
                  <DarkModeIcon sx={{ fontSize: 20 }} />
                ) : (
                  <LightModeIcon sx={{ fontSize: 20 }} />
                )}
              </IconButton>
            </Tooltip>
          </Box>
          <ConfirmRouteChange {...ConfirmRouteChangeProps} />
        </Box>
      </Container>
    </Box>
  );
}

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
    isFormDirty: getIsFormDirty(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setIsformDirty: (isFormDirty) => dispatch(setIsformDirty(isFormDirty)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
